import React from "react";
import { css } from "@emotion/core";
import styled from "@emotion/styled";
import Img from "gatsby-image/withIEPolyfill"
import Link from "../link";
import { color } from "../defaults/styles/theme";
import  mq from "../defaults/styles/mediaquerys";
import { wrapper } from "../defaults/styles/elements";
import StartupLogo from './logo-startup';



export const CardList = styled.ul`
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  margin: 0;
  ${wrapper};
  padding-top: 5rem;
  padding-bottom: 5rem;
  max-width: 24rem;
  ${mq[0]} {
    flex: 1.4224 0 38.8574%;
    max-width: 40rem;
  }
  ${mq[1]} {
    flex: 1.4224 0 25.88829%; 
    max-width: 55rem;
  }
  ${mq[2]} {
    ${wrapper};
    padding-top: 5rem;
    padding-bottom: 5rem;
  }
`

export const CardListItem = ({ children, ...props }) => {
    return (
      <li
        key={props.key}
        css={css`
          flex: 0 0 100%;
          margin-bottom: ${props.placeholder_item ? "0" : "1rem"};
          min-width: 0;
          ${mq[0]} {
            margin-bottom: ${props.placeholder_item ? "0" : "2rem"};
            flex: 1.4224 0 38.8574%;
            margin-right: 1rem;
            &:nth-of-type(2n) {
              margin-right: 0;
            }
          }
          ${mq[1]} {
            flex: 1.4224 0 calc(50% - 1rem);
            &:nth-of-type(2n + 2) {
              margin-right: 0;
            }
            &:nth-of-type(2n + 1) {
              margin-right: 1rem;
            }
          }

          ${mq[2]} {
            flex: 1.4224 0 30.88829%;
            &:nth-of-type(2n + 2) {
              margin-right: 1rem;
            }
            &:nth-of-type(3n + 3) {
              margin-right: 0;
            }
          }

          ${mq[3]} {
            flex: 1.4224 0 calc(25% - 3rem);
            &:nth-of-type(3n + 3) {
              margin-right: 1rem;
            }
            &:nth-of-type(4n + 4) {
              margin-right: 0;
            }
          }
        `}
      >
        {children}
      </li>
    )
}

export const Card = ({children}) => {
    return (
        <>
            <div css={css`
                background: white;
                border-radius: 3px;
                overflow: hidden;
                position: relative;
                height: 100%;
            `}>
                {children}
            </div>
        </>
    )
}

export const CardLinkWrapper = ({children, cardLink, className, active}) => {
    const styleLink = css`
      position: relative;
      display: block;
      height: 100%;
      width: 100%;
      text-decoration: none;
      color: ${color.main_dark};
      &:after {
        content: "";
        background: grey;
        position: absolute;
        width: calc(100% - 2px);
        top: 100%;
        left: 50%;
        height: 1px;
        transform: translateX(-50%);
        opacity: 0.5;
      }
    `
    return(
        <>
          {active === 'true' ? (
            <Link
              to={cardLink}
              className={className}
              css={styleLink}>
              {children}
            </Link>
          ) : (
            <div className={className} css={styleLink}>
              {children}
            </div>
          )}
        </>
    )
}


export const CardMedia = ({ children, placeholder }) => {
    let image = '';
    if (children) {
        image = children.childImageSharp.fluid
    } else {
        image = placeholder;
    }

    return (
        <div css={css`
            height: 11rem;
            overflow: hidden;
        `}>
           <Img fluid={image} objectFiter="cover" objectPosition="center top" css={css`
               height: 100%;
               width: 100%;
           `}/> 
        </div>
    )
};

export const CardMediaLogo = ({ className, logo, recordId }) => {

    return (
      <div
        className={className}
        css={css`
          height: 11rem;
          overflow: hidden;
          background: ${color.main_dark};
          display: flex;
          align-items: center;
          justify-content: center;
        `}
      >
        <div
          css={css`
            width: 50%;
            height: 40%;
            svg {
              fill: white;
              width: 100%;
              height: 100%;
            }
          `}
        >
          { logo ? logo : recordId ? <StartupLogo id={recordId} /> : '' }
        </div>
      </div>
    )
};


export const CardContent = ({ children }) => {
    return (
        <div css={css`
            padding: 1.5rem;
        `}>
            {children}
        </div>
    )
};

export const ContentHead = ({ children }) => {
    return (
        <div css={css`
            padding-bottom: 2rem;
        `}>
            {children}
        </div>
    )
};

export const ContentEyebrow = ({children}) => {
    return (
        <div css={css`
            p {
                font-size: .8rem;
                font-weight: 400;
            }
        `}>
            {children}
        </div>
    )
};

export const ContentTitle = ({ children }) => {
    return (
        <div css={css`
            font-weight: 500;
        `}>{ children }</div>
    )
};

export const ContentSub = ({children}) => {
    return (
        <div css={css`
            p {
                font-size: .85rem;
                padding: 0;
                margin: 0;
            }
        `}>
            { children }
        </div>
    )
};

export const CardTitle = ({className, children}) => {
    return (
      <div className={className} css={css`
        margin-bottom: .75em;
      `}>
        <h3
          css={css`
            font-size: 1.15em;
            font-weight: 600;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            display: inline-block;
            /* width: 12rem; */
            max-width: 100%;
            line-height: 1.25rem;
          `}
        >
          {children}
        </h3>
      </div>
    )
};

export const CardUrl = ({className, url, orig_url}) => {
    return (
      <div className={className}>
        <Link
          to={orig_url ? orig_url : "https://" + url}
          css={css`
            font-size: 0.85em;
            color: ${color.main_dark};
            text-decoration: none;
            position: relative;
            margin-top: 0.5em;
            display: inline-block;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            max-width: 100%;
            &:after {
              content: "";
              background: ${color.main_dark};
              bottom: 0;
              left: 0;
              height: 1px;
              width: 100%;
              position: absolute;
              opacity: 0.18;
            }
          `}
        >
          {url}
        </Link>
      </div>
    )
};

export const CardLocation = ({className, country, city}) => {
    
    return (
      <div
        className={className}
        css={css`
          font-size: 0.85em;
          margin-bottom: 0.75rem;
        `}
      >
        <p
          css={css`
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            max-width: 100%;
          `}
        >
          {country}
          {city ? ", " + city : ""}
        </p>
      </div>
    )
};

export const CardType = ({className, type}) => {
    
    return(
        <div className={ className } css={css`
            font-size: .75em;
            background: ${color.accent_light};
            display: inline-block;
            padding: .35em .85em;
            border-radius: 3px;
            line-height: 1em;
        `}>
            <p>
                { type }
            </p>
        </div>
    )
};

export const CardProgram = ({className, program }) => {
  let program_sorted = program.sort();
  return (
    <>
      <div className={className} css={css`
        margin-bottom: .5em;
        line-height: 1em;
      `}>
        {program_sorted.map((item, index) => (
          <CardType type={item} key={index} css={css`
            &:not(:last-of-type) {
              margin-right: .5em;
            }
          `} />
        ))}
      </div>
    </>
  )
};


